import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { WorkspaceProvider } from '@/contexts/WorkspaceContext';
import { ToastProvider } from '@/components/Toast';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Onboarding from '@/pages/Onboarding';
import AppShell from '@/components/AppShell';
import Dashboard from '@/pages/Dashboard';
import Faktury from '@/pages/Faktury';
import Klienti from '@/pages/Klienti';
import Vydavky from '@/pages/Vydavky';
import Nastavenia from '@/pages/Nastavenia';
import Privacy from '@/pages/Privacy';
import NewInvoiceScreen from '@/components/modals/NewInvoiceScreen';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceProvider>
          <ToastProvider>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Onboarding — protected (must be logged in) but no workspace required */}
            <Route path="/onboarding" element={<ProtectedRoute requireWorkspace={false}><Onboarding /></ProtectedRoute>} />

            {/* Main app shell — protected + requires workspace */}
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/faktury" element={<Faktury />} />
              <Route path="/faktury/nova" element={<NewInvoiceScreen />} />
              <Route path="/faktury/:id/upravit" element={<NewInvoiceScreen />} />
              <Route path="/klienti" element={<Klienti />} />
              <Route path="/vydavky" element={<Vydavky />} />
              <Route path="/nastavenia" element={<Nastavenia />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ToastProvider>
        </WorkspaceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
